import { GoogleGenerativeAI } from "@google/generative-ai";

const genAI = new GoogleGenerativeAI("AIzaSyDIAmFUx6H-m-sTQjexASqi5o2_O3hSaDk");

export async function sendMsgToGemini(message) {
  const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" });

  const result = await model.generateContent(message);
  const response = result.response;
  console.log(response.text());

  return response.text();
}
